var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{staticClass:"has-text-centered"},[_c('div',{staticClass:"is-stretch"},[_c('img',{attrs:{"src":require("@/assets/images/not-found.svg"),"alt":"Not Found Image"}}),_c('router-link',{staticClass:"button is-primary is-outlined mt-5 p-5",attrs:{"to":"/"}},[_vm._v(" Go to homepage ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }